export default __webpack_public_path__ + "static/presentation-1ce1ea884abd0b5e0838409b9397261d.png";